import { PagedRequest } from './paged-request';

export class CollectionUsersRequest extends PagedRequest {
  public collectionId: number;
  public sortAscending: boolean;
  public sortColumn: string;
}
